import React from 'react';
import { element, oneOfType, arrayOf, bool } from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import EmptyWrapper from './empty';

export const messages = defineMessages({
  noItemsFound: {
    id: 'emptyWrapper.noItemsFound',
    defaultMessage: 'No items found',
  },
});

// @deprecate
const withEmptyContext = ({ children, empty, message, reasons }) => (
  !empty
    ? children
    : <EmptyWrapper
      title={message || <FormattedMessage {...messages.noItemsFound} />}
      reasons={reasons}
    />
);

withEmptyContext.propTypes = {
  children: oneOfType([element, arrayOf(element)]).isRequired,
  empty: bool.isRequired,
  message: element,
  reasons: oneOfType([arrayOf(element), element]),
};

withEmptyContext.defaultProps = {
  reasons: undefined,
  message: undefined,
};

export default withEmptyContext;
